import { Navigate, useLocation } from "react-router-dom";

import { Box } from "@/components/atoms";
import { Main } from "#/templates";
import { adminMenu } from "./constants";
import { useApi } from "@/api";

const RequireAdmin = ({ children }: { children: JSX.Element }) => {
  const { session } = useApi();
  const location = useLocation();

  if (!session.isLoggedIn() || !session.user?.admin) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return (
    <Main
      user={{
        firstName: session.user.firstName,
        lastName: session.user.lastName,
      }}
      navigation={{ menus: adminMenu, onLogout: session.logout }}
      onEditProfile={() => console.log('TODO') }
      
    >
      <Box margin="50px 0 0px">
        {children}
      </Box>
    </Main>
  );
}

export default RequireAdmin;
